import { render, staticRenderFns } from "./GenerateAccessToken.vue?vue&type=template&id=2a694ada&scoped=true&"
import script from "./GenerateAccessToken.vue?vue&type=script&lang=ts&"
export * from "./GenerateAccessToken.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateAccessToken.vue?vue&type=style&index=0&id=2a694ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a694ada",
  null
  
)

export default component.exports